import type { IconData } from '@stacksjs/iconify-core'

export const filesF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 4H7a2 2 0 0 0-2 2v9H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2zM8 5h7l3 3v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default filesF
